import {landShapeUrl, landThumbnailUrl} from '#/utils/land-utils';
import {ClassName} from '#/utils/utils';
import {Land} from '@shareland/shareland-common';
import {FunctionComponent, useRef} from 'react';

export const LandThumbnail: FunctionComponent<{className: string; land: Land}> = ({className, land}) => {
  const hasErrorRef = useRef(false);

  const setDefaultImage = (ev: any) => {
    if (hasErrorRef.current) return;
    ev.target.src = landShapeUrl(land);
    hasErrorRef.current = true;
  };

  return <img className={className} src={landThumbnailUrl(land)} alt={land.name} onError={setDefaultImage} />;
};

export const LandShapeImage: FunctionComponent<{land: Land} & ClassName> = ({className = '', land}) => {
  return <img className={className} src={landShapeUrl(land)} alt={land.name} />;
};
